import { LoaderFunctionArgs } from "react-router";

export default async function invitationLoader(args: LoaderFunctionArgs) {
  return args.params.invitationId;
}
